<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN9-M/IN9-M.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.0-M Motorcycle Cockpit Domain Controller</div>
                <div class="detail-banner-desc">
                    IN9.0-M is based on the 3rd-generation platform SA8155P;<br />
                    The display can be equipped with 12.3-inch display or 4-inch conventional display;<br />
                    The instrument cluster supports display mode switching, 3D animation effects, high quality sound effects and other infotainment functions.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            Qualcomm 3th-generation Snapdragon digital cockpit platform.<br />
                        </div>
                        <div>
                            Multiple operating systems (QNX/Android) on single chip.<br />
                        </div>
                        <div>
                            Supports 1 display, 1 Gigabit Ethernet port, 1 CAN (FD) port, and 2 LIN ports.<br />
                        </div>
                        <div>
                            Supports USB 2.0, WiFi, and dual Bluetooth headsets.<br />
                        </div>
                        <div>
                            Supports an external amplifier for music playback anytime, anywhere.<br />
                        </div>
                        <div>
                            Supports FM/AM radio.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN9-M/IN9-M-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">7nm</div>
                                    <div class="k">Process</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">105K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1100 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">12G+64G</div>
                                    <div class="k">Memory</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1000 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>      
                                <div class="spec-item spec-item-last">
                                    <div class="v">BT5.0 & BLE、WIFI5</div>
                                    <div class="k">BT-WIFI</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Round cluster × 2 or Rectangle cluster × 1</div>
                                    <div class="k">Display</div>
                                </div>                    
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                                           
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN9-M/IN9-M-1.jpg" alt="200-1-02">
                    </div>

                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'IN 9.0-M Motorcycle Cockpit Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/IN9-M.html'
};

import { createApp } from 'vue';
import App from './IN9-M.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN9-M.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
